import { createAction } from 'redux-actions';

export const fetchUsers = createAction('FETCH_USERS');
export const fetchUsersSuccess = createAction('FETCH_USERS_SUCCESS');

export const updateUser = createAction('UPDATE_USER');
export const updateUserSuccess = createAction('UPDATE_USER_SUCCESS');

export const userInvalid = createAction('USER_INVALID');
